<template>
    <label class="font-poppins color-dark-blue" :for="id">
        {{ label }}{{ isRequired ? '*': '' }}{{ showLabelColon ? ':' : '' }}
    </label>
</template>

<script>
export default {
    props: {
        id: {
            type: String,
            default() {
                return `select-input-${this._uid}`
            },
        },
        label: String,
        showLabelColon: {
            type: Boolean,
            default: false,
        },
        isRequired: {
            type: Boolean,
            default: false,
        },
    },
}
</script>
